const API_HOST = import.meta.env.VITE_LYSIMED_API_HOST;
const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;

export { API_HOST, SENTRY_DSN };
